import { MutationTree } from 'vuex';
import { AUTHENTICATION } from '@/store/mutation-types';
import { AuthenticationState } from './state';

export const mutations: MutationTree<AuthenticationState> = {
    [AUTHENTICATION.SET_SIGN_IN_AZURE_CALLED](state, isAzureCalled: boolean) {
        state.signInAzureHasBeenCalled = isAzureCalled;
    },
    [AUTHENTICATION.SET_SIGN_IN_AZURE_SUCCESSFUL](state, isSuccess: boolean) {
        state.signInAzureIsSuccessful = isSuccess;
    },
    [AUTHENTICATION.SET_SIGN_IN_AZURE_ERROR](state, isError: string) {
        state.signInAzureError = isError;
    },
    [AUTHENTICATION.SET_CODE_VERIFIE](state, codeVerifie: string) {
        state.codeVerifier = codeVerifie;
    },
    [AUTHENTICATION.SET_CODE](state, code: string) {
        state.code = code;
    },
    [AUTHENTICATION.SET_TOKEN](state, token: string) {
        state.tokenAzure = token;
    },
    [AUTHENTICATION.SET_ACCESS_TOKEN](state, accesToken: string) {
        state.accessToken = accesToken;
    },
    [AUTHENTICATION.SET_USER_MAIL](state, mail: string | undefined) {
        state.user.email = mail;
    },
    [AUTHENTICATION.SET_USER_FULL_NAME](state, name: string | undefined) {
        state.user.fullName = name;
    },
    [AUTHENTICATION.SET_ACQUIRING_TOKEN](state, acquiring: boolean) {
        state.acquiringTokenSilent = acquiring;
    },
    [AUTHENTICATION.SET_PORTAIL](state, portail: string) {
        state.portail = portail;
    },
};
